import React from 'react';
import { fonts, colors, components, typography } from '@peachjar/components';

import OneTree from './OneTree.svg';
import FewTrees from './FewTrees.svg';
import ManyTrees from './ManyTrees.svg';
import { MAX_NUMBER_OF_SCHOOLS_ALLOWED_WITHOUT_PROPOSAL } from '../../../constants';

const FEW_TREE_TRIGGER = Math.floor(
  MAX_NUMBER_OF_SCHOOLS_ALLOWED_WITHOUT_PROPOSAL / 2
);
const MANY_TREE_TRIGGER = MAX_NUMBER_OF_SCHOOLS_ALLOWED_WITHOUT_PROPOSAL;

// Show a different tree svg depending on the number of schoools
const Trees = ({ numberOfSchools }) => {
  if (numberOfSchools > MANY_TREE_TRIGGER) {
    return <ManyTrees />;
  }
  if (numberOfSchools >= FEW_TREE_TRIGGER) {
    return <FewTrees />;
  }
  return <OneTree />;
};

export default Trees;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Pricing/components/Trees.jsx